import React, { useContext } from 'react';
import styled from 'styled-components';
import { FlexContainer, Text, ExternalLink } from 'common/styles';
import Modal from 'ui/components/DoziModel';
import illustrationConfig from 'styles/illustrations';
import { OSContext } from 'ui/containers/Providers/OSProvider';

export const UnlockButton = styled.button`
  display: flex;
  align-items: center;
  padding: 4px 16px;
  background: #417dff;
  border-radius: 20px;
  border: none;
  margin: 24px auto 0;
  width: 91px;
  height: 30px;
  cursor: pointer;
  justify-content: space-between;
  & > svg {
    margin-right: 8px;
  }
`;

const UnlockScreen = ({ open, hideModal, onExited }) => {
  const { activeOS } = useContext(OSContext);
  return (
    <>
      {open ? (
        <Modal
          title="We’ve got your back!"
          width={'400px'}
          maxWidth={400}
          titlePadding={'21px 32px 19px 32px'}
          titleMargin={'0'}
          onClose={hideModal}
        >
          <FlexContainer flexDirection={'column'} padding={'26px 34px 33px 30px'}>
            <img
              src={illustrationConfig.congrats[activeOS]}
              width="148px"
              height="120px"
              alt="success-icon"
            />
            <Text fontSize={12} lineHeight={20} margin={'5px 0 10px 0'} className="text-center">
              Our team will be in touch shortly! Please reach out to us at{' '}
              <ExternalLink
                href="mailto:chatsuccess@zoominfo.com"
                color={'#417DFF'}
                fontSize={12}
                lineHeight={20}
              >
                chatsuccess@zoominfo.com
              </ExternalLink>{' '}
              for any questions about your account.
            </Text>
          </FlexContainer>
        </Modal>
      ) : (
        ''
      )}
    </>
  );
};

export default UnlockScreen;
